module.exports = __webpack_public_path__ + "static/media/206-gallery19.461c30e4.jpg";